<template>
  <div class="container">
  <div class="m_msg_main">
    <!-- title -->
    <div class="m_title">淘宝/天猫搜券视频教程</div>
    <!-- video -->
    <div class="m_video">
      <video id="myVideo" ref="myVideo" src="https://jt.weiquaner.com/e/extend/activity/api/help.mp4" autoplay="true"  class="video"></video>
    </div>
    <!-- 图片教程 -->
    <div v-show="false">
      <img :src="gobalUrl+helpPic" v-for="helpPic in helpPics" alt="">
    </div>
    <div class="m_photo_study">
      <div class="m_photo_study_btn" v-if="videoShow" @click="picView">查看图片教程</div>
      <div class="m_photo_study_btn" v-else @click="videoView">播放视频教程</div>
    </div>
    <!-- 常见问题 -->
    <div class="m_question_list">
      <div class="m_question_title">
        <span>其他常见问题</span>
        <span class="icon_remind instructor" @click="showCode">搜券指导员</span>
      </div>
      <questionitem v-for="(item,index) in list"  :key="index":question="item"></questionitem>
    </div>
    <!-- 意见反馈
     -->
    <div class="m_feedback">
      <button class="suggestionButton">意见反馈</button>
    </div>
  </div>
  <div
  <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true" id="pswp">

    <!-- Background of PhotoSwipe.
             It's a separate element, as animating opacity is faster than rgba(). -->
    <div class="pswp__bg"></div>

    <!-- Slides wrapper with overflow:hidden. -->
    <div class="pswp__scroll-wrap">

      <!-- Container that holds slides. PhotoSwipe keeps only 3 slides in DOM to save memory. -->
      <div class="pswp__container">
        <!-- don't modify these 3 pswp__item elements, data is added later on -->
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>

      <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
      <div class="pswp__ui pswp__ui--hidden">

        <div class="pswp__top-bar">

          <!--  Controls are self-explanatory. Order can be changed. -->

          <div class="pswp__counter"></div>

          <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

          <button class="pswp__button pswp__button--share" title="Share"></button>

          <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

          <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

          <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
          <!-- element will get class pswp__preloader--active when preloader is running -->
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip"></div>
        </div>

        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                </button>

        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                </button>

        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>

      </div>

    </div>
  </div>

  <mt-popup
    v-model="popupVisible"
    position="top" class="show_code_wrapper" closeOnClickModal="true" modal="true">
    <div class="show_code_content">
      <img :src="gobalUrl+helpPics[10]" class="show_code_img" />
      <p class="show_code_text">
        加指导员微信：xiaopei116<br/>或者扫上面二维码
      </p>
    </div>
  </mt-popup>
</div>
</template>
<script type = "span/ecamscript-6">
  import Vue from 'vue'
  import Questionitem from "./questionitem"
  import {config} from "../../common/js/common.js"
  import photoswipe from 'photoswipe'
  import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'
  import 'photoswipe/dist/photoswipe.css'
  import 'photoswipe/dist/default-skin/default-skin.css'
  import { Popup } from 'mint-ui';
  Vue.component(Popup.name, Popup);
  export default {
    name:"help",
    data(){
      return{
        popupVisible:false,
        videoShow:true,
        gobalUrl:config.gobalUrl,
        helpPics:["images/help/1.jpg","images/help/2.jpg","images/help/3.jpg","images/help/4.jpg","images/help/5.jpg","images/help/6.jpg","images/help/7.jpg","images/help/8.jpg","images/help/9.jpg","images/help/10.jpg","qun.jpg"],
        list:[
          {"title":"搜券王是什么？","content":"搜券王收集了淘宝等网购平台上的海量内部大额优惠券（一般情况下，您直接在卖家店铺上是看不到这些优惠券）。您可在网购下单前，使用搜券王来查找是否有您想要的优惠券。如果有券，则可直接领券下单，省下一笔可观的费用，并在购买后提交订单编号可再获得券币奖励；如果无券，也可直接点击我们提供的引导按钮后再下单，并在购买后提交订单号即可获得大量的券币。注1：券币可真免费（无需再花一分钱）兑换各大平台的视频VIP会员、以及高品质生鲜产品。注2：当然您也可以在闲暇时，在淘券、小编推荐等栏目内随便逛逛，有时候，精品优惠券只赠有缘人。"},
          {"title":"在搜券王上可以购物吗？","content":"很抱歉，搜券王不是购物平台，而是海量内部大额优惠券的检索工具。您可以使用搜券王帮您省钱，也可以通过经常使用赚得券币兑换丰富的礼品。"},{"title":"为什么有的商品搜索不到优惠券？","content":"是的，因为并不是所有的淘宝或天猫商家都设置了内部券。对于没有优惠券的商品我们提供了返券币功能，找到了可以省钱，找不到可以赚券币，券币可以零元兑换各大视频网站的VIP会员，以及高品质的生鲜产品。"},{"title":"从这里搜到的券和商家店铺里的券是一样的吗？","content":"不一样，因为从搜券王搜到的优惠券是推广渠道专属优惠券，额度大且使用门槛更低。当然，在极少数情况下，会存在搜券王的优惠券和店铺优惠券一样。比如：双十一等购买节，商家会空前促销，这些内部券会短期内开放给所有人。"},{"title":"为什么有的优惠券面额那么大？","content":"因为商家想推新品、或新店要开张、或反复打造爆品等，他们都需要人气、需要成交量。所以就通过极高的优惠力度（甚至是亏本赚吆喝，也可理解为广告费）邀请各个推广媒介帮他们宣传出去，吸引聪明人过来体验（也可以理解为帮忙刷单走量），当商家攒够了好评和销量后，往往就会取消高额优惠券，再以原价+好评如潮吸引新买家，最终通过后者买单来平衡收益。注1：也有商家会一边通过隐藏内部券的方式走量赚好评，一边再以此吸引不知道有隐藏券的买家下单，只要最终有利可图，这种模式就会长期存在。注2：当然在您享受到如此优惠的同时，还体验到了商家的优质产品或服务的话，您自然也可能成为商家的忠实客户，这是双赢。注3：搜券王只是帮您找券，您领券后的交易行为是在淘宝天猫等平台上发生的，任何商品的售后或疑问，请直接找商家或淘宝处理，搜券王爱莫能助。注4：当您抢到高额优惠券，请别去咨询商家的店小二来求证！一来对方可能真不知情；二来他们自然愿意您用原价购买。所以往往求证的结果会说您的券无效，而其实您只需要在搜券王领券后再到淘宝上加个购物车就可验证。"}
        ]
      }
    },
    created(){

    },
    methods:{
      picView(prama1) {
        this.$refs.myVideo.pause()
        this.videoShow = false
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var picIndex = 0,
          items = [],
          item;
        for (var i = 0; i < this.helpPics.length; i++) {
          var img = new Image();
          var picSrc, picWidth, picHeight;
          picSrc = this.gobalUrl + this.helpPics[i];
          img.src = picSrc;

            picWidth = img.naturalWidth;
            picHeight = img.naturalHeight;

          item = {
            src: picSrc,
            w: picWidth,
            h: picHeight
          }
          items.push(item)
        }

        var options = {
          index: prama1,
        };


        var gallery = new photoswipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
      },
      showCode(){
        this.popupVisible=!this.popupVisible
      },
      videoView(){
        this.$refs.myVideo.play()
        this.videoShow = true
      }
    },
    mounted(){
      console.log(document.getElementById('pswp').getAttribute("aria-hidden"))
    },
    components:{
      "questionitem":Questionitem,
    },
    computed:{

    }


  }
</script>
<style lang="stylus">
  .m_title
    line-height: 100px
    font-size: 38px
    font-weight: 500
    color: #fa6700
    text-align: center
    background: #fff
  .video
    width:100%
  .m_photo_study
    padding: 30px 0
    width: 100%
    background: #fff
    margin-top:-5px
    .m_photo_study_btn
      width: 400px
      border-radius:40px
      font-size: 30px
      color: #fff
      background-image:linear-gradient(90deg,#ff8800,#ff4400)
      height: 80px
      line-height: 80px
      text-align:center
      margin:0 auto
  .m_question_list
    background:#fff
    margin-top:10px
    .m_question_title
      display:flex
      justify-content:space-between
      padding: 10px 30px
      padding-left: 50px
      font-size: 32px
      line-height: 60px
      .instructor
        padding: 5px 20px
        line-height: 48px
        border: 2px solid #fa6700
        border-radius: 6px
        font-size: 28px
        color: #fa6700
    .m_question
      width: 100%
      padding: 0 20px
      line-height: 88px
      border-top: 1px solid #f2f2f2
      /*px*/
      font-size: 30px
      color: #fa6700
      box-sizing:border-box
      .issueName
       display:flex
       justify-content:space-between
       align-items:center
      span
        color:#666
      .issuespan
        color: #999
        font-size: 28px
        line-height: 56px
        padding-bottom:20px
  .m_feedback
    margin: 20px auto 80px auto
    .suggestionButton
      width: 520px
      border: 1px solid #fa6700
      /*px*/
      color: #fa6700
      border-radius:40px
      background: #fff
      font-size: 30px
      height: 80px
      line-height: 80px
      margin:0 auto
      display:block
  .show_code_wrapper
    padding:80px 50px
    width:400px
    left:50%
    top:50%
    background:#fff
    transform:translate(-50%,-50%)
    border-radius:10px
    box-shadow:0 0 5px rgba(0,0,0,0.5)
    .show_code_img
      width:200px
      height:200px
      display:block
      margin: 0 auto
    .show_code_text
      font-size:28px
      text-align:center




</style>



// WEBPACK FOOTER //
// src/components/userCenter/help.vue